import moment from "moment";
import Vue from 'vue';
import LogService from '@/services/LogService';
import { router } from '@/router';
import _ from "lodash";
import store from '@/store';
import { authenticationService } from "@/services/AuthenticationService";
import { movieWeekEnd } from "@/helper/collection";


function initialState() {
    return {
        logObject: {
            user_name: null,
            user_id: null,
            cinema_id: null,

            // 
            action: null,
            page_name: null,
            logDateTime: null,
            //
            api_name: null,
            //

            ip: null,
            country_name: null,
            country_code: null,
            latitude: null,
            longitude: null,
            currency_code: null,
            currency_name: null,
        }
    };
};
const state = initialState();

const mutations = {
    ON_RESET_LOG_STORE_STATE: (state, payload) => {
        // state = initialState();
        const s = initialState()
        Object.keys(s).forEach(key => {
            state[key] = s[key]
        })
    },
    ON_SET_LOG_INFO: (state, payload) => {
        state.logObject = {
            ...state.logObject,
            ...payload
        };
    }
};

const actions = {
    onResetLogStoreState: async ({ dispatch, commit, state }, { ...payload }) => {
        await commit('ON_RESET_LOG_STORE_STATE');
    },
    onSetLog: async ({ dispatch, commit, state }, { ...payload }) => {
        await commit('ON_SET_LOG_INFO', payload);
    },
    onSetAndSendLog: async ({ dispatch, commit, state }, { ...payload }) => {
        await commit('ON_SET_LOG_INFO', payload);
        await dispatch('sendLogs')
    },
    sendLogs: ({ dispatch, commit, state }, { ...payload }) => {
        LogService.SendLog(state.logObject)
            .then((response) => {
                const { data } = response;
                if (data && data.status) {

                } else {
                    console.error('Status Error on sendLogs :', data.message);
                }
            }).catch((error) => {
                console.error('Catch Error on sendLogs :', error);
                // Vue.toasted.show("Catch Error on sendLogs", error);
            });
    },
    setIpDetails: ({ }, { ...payload }) => {
        LogService.GetIpDetails()
        // .then((response) => {
        //     console.log('response :', response);
        //     // const { data } = response;
        //     // if (data && data.status) {

        //     // } else {
        //     //     console.error('Status Error on sendLogs :', data.message);
        //     // }
        // }).catch((error) => {
        //     console.error('Catch Error on sendLogs :', error);
        //     // Vue.toasted.show("Catch Error on sendLogs", error);
        // });
    }
}

const getters = {
};

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/LogStore.js